export default function FilmHuman() {
  return (
    <article className="film-human film-human--quotes">
      <p className="film-quote" data-tour="human-quote">
        Real estate isn't paperwork. It's people.
      </p>
      <p className="film-deserve" data-tour="human-deserve">
        And every person deserves a smooth, organized, stress-free journey.
      </p>
    </article>
  );
}
